// extracted by mini-css-extract-plugin
export default {"title":"AllReviewPhotos_title__IQXhJ","photo":"AllReviewPhotos_photo__uBv47","container":"AllReviewPhotos_container__utAdL"};